import React from 'react';
import { isNullOrUndefined } from 'util';
import uuidv4 from 'uuid/v4';
import Autocomplete from '../hacks/react-autocomplete/Autocomplete.jsx';
import './autoCompleteTextInput.css';

export default class AutoCompleteTextInput extends React.Component {
    constructor(args) {
        super(args);

		let items = [];
		if (this.props.items) {
			items = this.props.items;
		}
        this.state = {
            value: this.clearValue(this.props.value),
			sessionKey: uuidv4(),
            items: []
        };

        this.lastValue = this.state.value;
        this.changeTimer = null;
        this.newSessionTimer = null;
		this.isMenuOpened = false;

		this.extendSessionTime();
	}

    componentWillReceiveProps(newProps) {
        let value = this.clearValue(newProps.value);
		if (newProps.items) {
			this.setState({ 
				value: value,
				items: newProps.items
			});
		} else {
			this.lastValue = value;
			if (this.state.value !== value) {
				this.requestSyncItems(value);
			}
			this.setState({ value: value });
		}
    }

    clearValue(value) {
        if (isNullOrUndefined(value)) {
            return "";
        } else {
            var actualValue = "" + value;
			if (this.props.maxLength && actualValue.length > this.props.maxLength) {
				actualValue = actualValue.substring(0, this.props.maxLength);
			}
			return actualValue;
        }
    }

	genSessionKey() {
		this.extendSessionTime();
		this.setState({sessionKey: uuidv4()});
	}

	extendSessionTime() {
		if (this.newSessionTimer) {
			clearTimeout(this.newSessionTimer);
		}
		this.newSessionTimer = setTimeout(() => this.genSessionKey(), 10000);
	}

	requestSyncItems(value) {
		if (this.changeTimer) {
			clearTimeout(this.changeTimer);
		}
		if (this.props.disabled) {
			this.changeTimer = null;
		} else {
			this.changeTimer = setTimeout(() => this.syncItems(value), 1000);
		}
	}

    syncItems(value) {
        if (this.changeTimer) {
            clearTimeout(this.changeTimer);
            this.changeTimer = null;
        }

		if (this.props.items) {
			return;
		} else {
			this.extendSessionTime();
			let fixedValue = value.trim();
			if (fixedValue.length >= 3) {
				if (this.props.loadItems) {
					this.props.loadItems(fixedValue, this.state.sessionKey)
						.then(items => {
							this.setState({ items: items });
						});
				}
			} else {
				this.setState({ items: [] });
			}
		}
    }

    handleInputValueChanged(e) {
        let value = this.clearValue(e.target.value);
        if (value !== this.lastValue) {
            this.lastValue = value;
            this.setState({ value: value });
            let fieldValue = value === "" ? null : value;
            if (this.props.onChange) {
                this.props.onChange(fieldValue);
            }
			this.requestSyncItems(value);
        }
    }

    handleInputBlur() {
        if (this.props.onEditComplete) {
            this.props.onEditComplete();
        }
    }

    handleInputKeyDown(e) {
        if (e.keyCode === 13) {
			if (!this.isMenuOpened) {
				this.handleInputBlur();
			}
			e.preventDefault();
        }
    }

    handleItemSelection(item) {
        if (this.props.onItemSelect) {
            this.props.onItemSelect(item);
        }
    }

	getInputStyle() {
		if (this.props.isItemSelected) {
			return { fontWeight: 'bold' };
		} else {
			return {};
		}
	}

	renderInput(props) {
		if (this.props.multi) {
			return <textarea rows="3" {...props} />;
		} else {
			return <input {...props} />;
		}
	}

    render() {
		let renderItemValue = this.props.renderItemValue;
		if (!renderItemValue) {
			renderItemValue = (item) => this.props.getItemValue(item);
		}
        return (
            <Autocomplete id={this.props.id}
                title={this.props.title}
                value={this.state.value}
                items={this.state.items}
                onChange={e => this.handleInputValueChanged(e)}
                onSelect={(value, item) => this.handleItemSelection(item)}
				onMenuVisibilityChange={isOpen => this.isMenuOpened = isOpen}
                getItemValue={item => this.props.getItemValue(item)}
                renderItem={(item, isHighlighted) =>
                    <div key={this.props.getItemKey(item)} className={"Select-option " + (isHighlighted ? 'is-focused' : '')}>
                        {renderItemValue(item)}
                    </div>
                }
				renderMenu={(items, value, style) =>
					<div className="autocomplete-menu" children={items} />
				}
                inputProps={{
                    className: "form-control " + (this.props.className ? this.props.className : ""),
					style: this.getInputStyle(),
                    title: this.props.title,
                    disabled: this.props.disabled,
                    onBlur: () => this.handleInputBlur(),
                    onKeyDown: e => this.handleInputKeyDown(e),
					maxLength: this.props.maxLength
                }}
				shouldItemRender={this.props.shouldItemRender}
				renderInput={props => this.renderInput(props)}
                wrapperStyle={{}}
                wrapperProps={{
					className: 'autocomplete-wrapper'
				}}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./App/controls/autoCompleteTextInput.jsx